interface PublishStatusBadgeProps {
  status: 'Published' | 'Draft'
}

export const PublishStatusBadge = ({ status }: PublishStatusBadgeProps) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'Published':
        return ' text-[#03750B] border-[#03750B]'
      case 'Draft':
        return 'text-[#AB0303] border-[#AB0303]'
      default:
        return 'bg-muted text-foreground border-border'
    }
  }

  return (
    <span className={`px-3 py-1 text-[12px] font-[600] rounded-[10px] w-[115px] h-[25px] flex justify-center items-center border ${getStatusStyles()}`}>
      {status === 'Published' ? <>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
        < path d="M8.5 13.167V3.83362" stroke="#03750B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3.82812 8.50028L8.49479 3.83362L13.1615 8.50028" stroke="#03750B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </svg>  Published </> :
        <>
          <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
            <path d="M7.80729 3.2498V5.41646H9.16146M8.44917 1.08313H5.91146C5.62414 1.08313 5.34859 1.19727 5.14543 1.40043C4.94226 1.6036 4.82813 1.87915 4.82812 2.16646V8.66646C4.82812 8.95378 4.94226 9.22933 5.14543 9.4325C5.34859 9.63566 5.62414 9.7498 5.91146 9.7498H10.2448C10.5321 9.7498 10.8077 9.63566 11.0108 9.4325C11.214 9.22933 11.3281 8.95378 11.3281 8.66646V3.92255C11.3281 3.77822 11.2993 3.63536 11.2433 3.50235C11.1873 3.36933 11.1052 3.24884 11.002 3.14796L9.20642 1.39188C9.00403 1.19399 8.73223 1.08317 8.44917 1.08313Z" stroke="#AB0303" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.16406 9.74953V10.8329C9.16406 11.1202 9.04993 11.3957 8.84676 11.5989C8.6436 11.8021 8.36805 11.9162 8.08073 11.9162H3.7474C3.46008 11.9162 3.18453 11.8021 2.98136 11.5989C2.7782 11.3957 2.66406 11.1202 2.66406 10.8329V4.87453C2.66406 4.58721 2.7782 4.31166 2.98136 4.1085C3.18453 3.90534 3.46008 3.7912 3.7474 3.7912H4.83073" stroke="#AB0303" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Draft
        </>
        
        }
    </span>
  )
}